import EditablePropsType from '../../../types/composer';
import { BACKGROUND_COLOR_OPTIONS } from '../../../constants/composer';

export const overrideBackgroundSchema = {
  type: EditablePropsType.Select,
  label: 'Override Background Color',
  name: 'overrideBackground',
  selectOptions: {
    options: BACKGROUND_COLOR_OPTIONS,
  },
};

export default overrideBackgroundSchema;
